import { createAction } from '@reduxjs/toolkit';

// Action Types
export const SET_CURRENT_JOB_ID = 'menuJobId/setCurrentJobId';

// Action Creators
export const setCurrentJobId = createAction<string>(SET_CURRENT_JOB_ID);

// Initial State
export interface MenuJobIdState {
  currentJobId: string | null;
}

export const initialState: MenuJobIdState = {
  currentJobId: null
};
